import { render, staticRenderFns } from "./RchCreditNote.vue?vue&type=template&id=68e1fcd6&scoped=true&"
import script from "./RchCreditNote.vue?vue&type=script&lang=js&"
export * from "./RchCreditNote.vue?vue&type=script&lang=js&"
import style0 from "./RchCreditNote.vue?vue&type=style&index=0&id=68e1fcd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e1fcd6",
  null
  
)

export default component.exports